import { Component, inject, Input, OnInit } from '@angular/core';
import { IonLabel, ModalController } from '@ionic/angular/standalone';
import {
  ModeControlData,
  ModeControlMultipleComponent,
} from '../../../../../../../../components/ecosystems/mode-control-multiple/mode-control-multiple.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { SlideModalController } from '../../../../../../../slide-modal.service';
import { IProduct } from '../../../../../IProduct';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { P0003601SpeedChoiceComponent } from '../../../../P0003601/Component/p0003601-speed-choice/p0003601-speed-choice.component';
import { P0003601EnSavoirPlusComponent } from '../../../../P0003601/EnSavoirPlus/p0003601-en-savoir-plus/p0003601-en-savoir-plus.component';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { P00037AutoChoiceComponent } from '../../../Component/p00037-auto-choice/p00037-auto-choice.component';
import { brandOverride } from '../../../../../../ECoSystemsHelper';

@Component({
  selector: 'app-p00037-electrolyseur-controle',
  templateUrl: './p00037-electrolyseur-controle.component.html',
  styleUrls: ['./p00037-electrolyseur-controle.component.scss'],
  imports: [IonLabel, ModeControlMultipleComponent, TranslatePipe],
})
export class P00037ElectrolyseurControleComponent implements OnInit {
  private slideModalcontroller: SlideModalController =
    inject(SlideModalController);
  private modalController: ModalController = inject(ModalController);
  private translateService: TranslateService = inject(TranslateService);

  @Input() productClass: IProduct | null = null;
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);

  public actionStack: DeviceActionStackService | null = null;

  constructor() {}

  buttons: ModeControlData[] = [
    {
      ref: 0,
      label: this.translateService.instant('P00037.dashboard.off'),
      icon: 'fa-kit fa-picto-off',
      color: 'color-red',
    },
    {
      ref: 1,
      label: this.translateService.instant('P00037.dashboard.manuel'),
      icon: 'fa-kit fa-picto-on',
      color: 'color-green',
    },
    {
      ref: 2,
      label: this.translateService.instant('P00037.dashboard.auto'),
      icon: 'fa-kit fa-picto-programme',
      color: 'color-orange',
      onPress: () => {
        this.openManual().finally(() => {});
      },
    },
    {
      ref: 4,
      label: this.translateService.instant('P00037.dashboard.boost'),
      icon: 'fa-kit fa-picto-boost24',
      color: 'color-orange',
    },
  ];

  getButtons(): ModeControlData[] {
    const modeFonctionnement =
      this.actionStack!.getValue('elCModeFonctionnement') ?? 0;

    let res = 'fa-kit fa-picto-programme';

    if (modeFonctionnement === 3) {
      res = 'fa-kit fa-picto-horloge';
    }

    this.buttons[2].icon = res;
    return this.buttons;
  }

  async openManual() {
    const modal = await this.modalController.create({
      component: P00037AutoChoiceComponent,
      componentProps: {
        value: this.actionStack!.getValue('elCModeFonctionnement') ?? 0,
        removeBoost: true,
      },
      cssClass: 'dynamic-height',
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      this.actionStack!.editValue(
        P00039DataRxTxIndex.SALT_Controle,
        'elCModeFonctionnement',
        data.value,
      );
      this.actionStack!.commit();
    }
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  changeMode(mode: number) {
    if (mode !== 2) {
      this.actionStack!.editValue(
        P00039DataRxTxIndex.SALT_Controle,
        'elCModeFonctionnement',
        mode,
      );
      this.actionStack!.commit();
    }
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly brandOverride = brandOverride;
}
